import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import type { Price} from "@@/shared/prices/price";
import { priceZodSchema } from "@@/shared/prices/price";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type {
    DiscountCondition} from "../../conditions/discount-condition";
import {
    discountConditionZodSchema,
} from "../../conditions/discount-condition";

type ValueDiscountCreateCommand = {
    readonly _id: string;
    readonly _type: "VALUE_DISCOUNT_CREATE_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly conditions: DiscountCondition[];
    readonly value: Price;
};

type CreateParams = Except<
    ValueDiscountCreateCommand,
    "_id" | "_type" | "_createdAt"
>;
const createValueDiscountCreateCommand = (params: CreateParams) => {
    const valueDiscountCreateCommand: ValueDiscountCreateCommand = {
        ...params,
        _id: generateId({ prefix: "value_discount_create_command__" }),
        _type: "VALUE_DISCOUNT_CREATE_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return valueDiscountCreateCommand;
};

const valueDiscountCreateCommandZodSchema: z.ZodSchema<ValueDiscountCreateCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("VALUE_DISCOUNT_CREATE_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        conditions: z.array(discountConditionZodSchema),
        value: priceZodSchema,
    });

export {
    createValueDiscountCreateCommand,
    valueDiscountCreateCommandZodSchema,
};
export type {
    CreateParams as CreateValueDiscountCreateCommandParams,
    ValueDiscountCreateCommand,
};
